"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Scale = exports.Tag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Styled = __importStar(require("./styled"));
var Tag;
(function (Tag) {
    Tag["SPAN"] = "span";
    Tag["P"] = "p";
    Tag["LI"] = "li";
    Tag["DIV"] = "div";
    Tag["H1"] = "h1";
    Tag["H2"] = "h2";
    Tag["H3"] = "h3";
    Tag["H4"] = "h4";
    Tag["H5"] = "h5";
    Tag["H6"] = "h6";
})(Tag || (exports.Tag = Tag = {}));
var Scale;
(function (Scale) {
    // Display
    Scale["DISPLAY_S"] = "DisplayS";
    Scale["DISPLAY_M"] = "DisplayM";
    Scale["DISPLAY_L"] = "DisplayL";
    Scale["DISPLAY_XL"] = "DisplayXL";
    // Heading
    Scale["SUB_HEADING"] = "SubHeading";
    Scale["HEADING"] = "Heading";
    Scale["HEADING_SMALL"] = "HeadingSmall";
    // Section
    Scale["SECTION_TITLE"] = "SectionTitle";
    Scale["SECTION_SUBTITLE"] = "SectionSubTitle";
    Scale["SECTION_BIG_TITLE"] = "SectionBigTitle";
    // Body
    Scale["BODY_MICRO_TEXT"] = "BodyMicroText";
    Scale["BODY_MICRO_TEXT_MAIN"] = "BodyMicroTextMain";
    Scale["BODY_BOLD_MICRO_TEXT"] = "BodyBoldMicroText";
    Scale["BODY_BOLD_MICRO_TEXT_MAIN"] = "BodyBoldMicroTextMain";
    Scale["BODY_TINY_TEXT"] = "BodyTinyText";
    Scale["BODY_TINY_TEXT_MAIN"] = "BodyTinyTextMain";
    Scale["BODY_TINY_TEXT_REGULAR"] = "BodyTinyTextRegular";
    Scale["BODY_BOLD_TINY_TEXT"] = "BodyBoldTinyText";
    Scale["BODY_SMALL_TEXT"] = "BodySmallText";
    Scale["BODY_SMALL_TEXT_MAIN"] = "BodySmallTextMain";
    Scale["BODY_SMALL_TEXT_REGULAR"] = "BodySmallTextRegular";
    Scale["BODY_SMALL_BOLD_TEXT"] = "BodySmallBoldText";
    Scale["BODY_SMALL_BOLD_TEXT_MAIN"] = "BodySmallBoldTextMain";
    Scale["BODY_REGULAR_TEXT"] = "BodyRegularText";
    Scale["BODY_REGULAR_TEXT_MAIN"] = "BodyRegularTextMain";
    Scale["BODY_TEXT"] = "BodyText";
    Scale["BODY_TEXT_MAIN"] = "BodyTextMain";
    Scale["BODY_BOLD_TEXT"] = "BodyBoldText";
    Scale["BODY_BOLD_TEXT_MAIN"] = "BodyBoldTextMain";
    /** @deprecated */
    Scale["SMALLTEXT"] = "SmallText";
    /** @deprecated */
    Scale["REGULARTEXT"] = "RegularText";
    /** @deprecated */
    Scale["SUBTITLE"] = "Subtitle";
    /** @deprecated */
    Scale["TITLE"] = "Title";
    /** @deprecated */
    Scale["BIGTITLE"] = "BigTitle";
    /** @deprecated */
    Scale["MEGATITLE"] = "MegaTitle";
})(Scale || (exports.Scale = Scale = {}));
const getComponent = (scale) => {
    switch (scale) {
        // Display
        case Scale.DISPLAY_S:
            return Styled.DisplaySmall;
        case Scale.DISPLAY_M:
            return Styled.DisplayMedium;
        case Scale.DISPLAY_L:
            return Styled.DisplayLarge;
        case Scale.DISPLAY_XL:
            return Styled.DisplayXLarge;
        // Heading
        case Scale.SUB_HEADING:
            return Styled.SubHeading;
        case Scale.HEADING:
            return Styled.Heading;
        case Scale.HEADING_SMALL:
            return Styled.HeadingSmall;
        // Section
        case Scale.SECTION_SUBTITLE:
            return Styled.SectionSubTitle;
        case Scale.SECTION_TITLE:
            return Styled.SectionTitle;
        case Scale.SECTION_BIG_TITLE:
            return Styled.SectionBigTitle;
        // Body
        case Scale.BODY_MICRO_TEXT:
            return Styled.BodyMicro;
        case Scale.BODY_MICRO_TEXT_MAIN:
            return Styled.BodyMicroMain;
        case Scale.BODY_BOLD_MICRO_TEXT:
            return Styled.BodyBoldMicro;
        case Scale.BODY_BOLD_MICRO_TEXT_MAIN:
            return Styled.BodyBoldMicroMain;
        case Scale.BODY_TINY_TEXT:
            return Styled.BodyTiny;
        case Scale.BODY_TINY_TEXT_MAIN:
            return Styled.BodyTinyMain;
        case Scale.BODY_TINY_TEXT_REGULAR:
            return Styled.BodyTinyRegular;
        case Scale.BODY_BOLD_TINY_TEXT:
            return Styled.BodyBoldTiny;
        case Scale.BODY_SMALL_TEXT:
            return Styled.BodySmall;
        case Scale.BODY_SMALL_TEXT_MAIN:
            return Styled.BodySmallMain;
        case Scale.BODY_SMALL_TEXT_REGULAR:
            return Styled.BodySmallRegular;
        case Scale.BODY_SMALL_BOLD_TEXT:
            return Styled.BodyBoldSmall;
        case Scale.BODY_SMALL_BOLD_TEXT_MAIN:
            return Styled.BodySmallBoldMain;
        case Scale.BODY_REGULAR_TEXT:
            return Styled.BodyRegular;
        case Scale.BODY_REGULAR_TEXT_MAIN:
            return Styled.BodyRegularMain;
        case Scale.BODY_TEXT:
            return Styled.Body;
        case Scale.BODY_TEXT_MAIN:
            return Styled.BodyMain;
        case Scale.BODY_BOLD_TEXT:
            return Styled.BodyBold;
        case Scale.BODY_BOLD_TEXT_MAIN:
            return Styled.BodyBoldMain;
        // deprecated
        case Scale.SMALLTEXT:
            return Styled.SmallText;
        case Scale.REGULARTEXT:
            return Styled.RegularText;
        case Scale.SUBTITLE:
            return Styled.SubtitleText;
        case Scale.TITLE:
            return Styled.TitleText;
        case Scale.BIGTITLE:
            return Styled.BigTitleText;
        case Scale.MEGATITLE:
            return Styled.MegaTitleText;
    }
    return Styled.BodyRegular;
};
exports.Text = (0, react_1.forwardRef)((props, ref) => {
    const { children, dangerouslySetInnerHTML, tag = Tag.P, scale = Scale.BODY_REGULAR_TEXT } = props, otherProps = __rest(props, ["children", "dangerouslySetInnerHTML", "tag", "scale"]);
    const childProps = Object.assign(Object.assign({ as: tag, ref }, (dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : { children })), otherProps);
    const TextComponent = getComponent(scale);
    return (0, jsx_runtime_1.jsx)(TextComponent, Object.assign({}, childProps));
});
exports.Text.displayName = 'Text';
exports.default = exports.Text;
